import {useIntl} from 'react-intl'

type DetailFieldProps = {
  label: string
  value: string | number | null | undefined
}

const DetailField = ({label, value}: DetailFieldProps) => {
  const intl = useIntl()
  return (
    <div className='row mb-4'>
      <label className='col-lg-4 fw-bold text-muted'>{intl.formatMessage({id: label})}</label>
      <div className='col-lg-8'>
        <span className='fw-bolder fs-6 text-dark'>{value || '-'}</span>
      </div>
    </div>
  )
}

export {DetailField}
